import { useCallback, useEffect, useMemo, useState } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';

import { cmApi } from '../../../../api';
import type { TableComponentRequestDto } from '../../../../api';

interface IUseUpdateTable {
  reportPackageCodeCm: string;
}

interface IData {
  report_package_code_cm?: string;
  status?: string;
  status_text?: string;
}

export const useUpdateTitle = ({
  reportPackageCodeCm,
}: IUseUpdateTable): { titleData: IData; updateTitle: () => void } => {
  const [titleData, setTitleData] = useState<IData>({});

  const updateTitle = useCallback(() => {
    const tableInfo = {
      aggregate: {},
      fields: ['report_package_code_cm', 'status_out'],
      hardFilter: [
        [
          {
            name: 'report_package_code_cm',
            type: FILTER.EQ,
            values: [reportPackageCodeCm],
            filterIsInverted: false,
          },
        ],
      ],
      filter: [],
      groupBy: [],
      limit: 1,
      offset: 0,
      openGroup: [],
      orderBy: [],
      resource: 'v_ctrl_main',
    };

    cmApi.tableComponentV2.getTableJson(tableInfo as unknown as TableComponentRequestDto).then((response) => {
      const result = response?.data as unknown as { data: IData };

      if (result && result.data) {
        setTitleData(result.data[0]);
      }
    });
  }, [reportPackageCodeCm]);

  useEffect(() => {
    updateTitle();
  }, [updateTitle]);

  return useMemo(() => ({ titleData, updateTitle }), [titleData, updateTitle]);
};
